module.exports = __webpack_public_path__ + "img/img48.3812fd04.svg";